
import { useContext } from 'react'

import { Error, Row, Spacer, Footer } from 'components/ui/form/Form'
import { ModalContext } from 'context/ModalContext'
import PostcodeSearchField from 'components/ui/form/PostcodeSearchField'
import { Button, InputFormik } from 'components/gsys-ui'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

const ClientForm = ({ isSubmitting, handleSubmit, error }) => {
  const modal = useContext(ModalContext)

  return (
    <>
      <Error>{error}</Error>
      <Row>
        <InputFormik name="name" label="Full name" />
      </Row>
      <Row>
        <InputFormik name="email" label="Email (optional)" />
        <InputFormik name="tel" label="Phone number (optional)" />
      </Row>
      <Spacer />
      <Row>
        <PostcodeSearchField name="pcode" label="Postcode lookup" />
      </Row>
      <Row>
        <InputFormik name="addr1" label="Address line 1" />
      </Row>
      <Row>
        <InputFormik name="addr2" label="Address line 2 (optional)" />
      </Row>
      <Row>
        <InputFormik name="city" label="City or town" />
        <InputFormik name="county" label="County (optional)" />
      </Row>
      <Spacer />
      <Footer>
        <Button variant="white" onClick={modal.close}>
          <XMarkIcon className="mr-1 w-5 h-5" />
          Cancel
        </Button>
        <Button variant="green" onClick={handleSubmit} loading={isSubmitting}>
          <CheckIcon className="mr-1 w-5 h-5" />
          Submit
        </Button>
      </Footer>
    </>
  )
}

export default ClientForm